import {
  // Speciality
  CREATECUSTOMPRODUCTSPECIALITY,
  GETCUSTOMPRODUCTSPECIALITY,
  UPDATECUSTOMPRODUCTSPECIALITY,
  DELETECUSTOMPRODUCTSPECIALITY,
  // Role
  CREATECUSTOMPRODUCTROLE,
  GETCUSTOMPRODUCTROLE,
  UPDATECUSTOMPRODUCTROLE,
  DELETECUSTOMPRODUCTROLE,
  // Department
  CREATECUSTOMPRODUCTDEPARTMENT,
  GETCUSTOMPRODUCTDEPARTMENT,
  UPDATECUSTOMPRODUCTDEPARTMENT,
  DELETECUSTOMPRODUCTDEPARTMENT,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // --- SPECIALITY CASES ---
    case CREATECUSTOMPRODUCTSPECIALITY:
      return {
        ...state,
        customproductspecialitySaveStatus: action.payload.success,
      };
    case GETCUSTOMPRODUCTSPECIALITY:
      return {
        ...state,
        customproductspecialityforAccountList: action.payload.data,
      };
    case UPDATECUSTOMPRODUCTSPECIALITY:
      return {
        ...state,
        customproductspecialityUpdateStatus: action.payload.success,
      };
    case DELETECUSTOMPRODUCTSPECIALITY:
      return {
        ...state,
        customproductspecialityDeleteStatus: action.payload.success,
      };

    // --- ROLE CASES ---
    case CREATECUSTOMPRODUCTROLE:
      return {
        ...state,
        customproductroleSaveStatus: action.payload.success,
      };
    case GETCUSTOMPRODUCTROLE:
      return {
        ...state,
        customproductroleList: action.payload.data,
      };
    case UPDATECUSTOMPRODUCTROLE:
      return {
        ...state,
        customproductroleUpdateStatus: action.payload.success,
      };
    case DELETECUSTOMPRODUCTROLE:
      return {
        ...state,
        customproductroleDeleteStatus: action.payload.success,
      };

    // --- DEPARTMENT CASES ---
    case CREATECUSTOMPRODUCTDEPARTMENT:
      return {
        ...state,
        customproductdepartmentSaveStatus: action.payload.success,
      };
    case GETCUSTOMPRODUCTDEPARTMENT:
      return {
        ...state,
        customproductdepartmentList: action.payload.data,
      };
    case UPDATECUSTOMPRODUCTDEPARTMENT:
      return {
        ...state,
        customproductdepartmentUpdateStatus: action.payload.success,
      };
    case DELETECUSTOMPRODUCTDEPARTMENT:
      return {
        ...state,
        customproductdepartmentDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}